import { render, staticRenderFns } from "./DescItem.vue?vue&type=template&id=03a58a62"
import script from "./DescItem.vue?vue&type=script&lang=js"
export * from "./DescItem.vue?vue&type=script&lang=js"
import style0 from "./DescItem.vue?vue&type=style&index=0&id=03a58a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports